// #flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";
import { config } from "dotenv";

const description = "A widget used to display a series of images to the user.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Photo gallery",
  id: "photo-gallery",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/photo-gallery/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "PhotoGalleryConfigTool" */ "app/components/tools/PhotoGalleryConfigTool/PhotoGalleryConfigTool"),
    loading: DynamicImportLoader,
    modules: ["PhotoGalleryConfigTool"]
  })
};

export default CONFIG;
